/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

/**
 * Different types of activities
 * Describe what happens in the activity
 */
export enum ActivityTypeEnum {
  ACKNOWLEDGE = "acknowledge",
  COMMENT = "comment",
  CREATE = "created",
  CREATE_ASSIGNEE = "addAssignee",
  CREATE_ASSOCIATED = "createAssociated",
  CREATE_ATTACHMENT_RESPONSE = "attachmentResponse",
  CREATE_BLUEPRINT = "createBlueprint",
  CREATE_CONTRACT = "contract",
  CREATE_COST = "createCost",
  CREATE_DOCUMENT = "document",
  CREATE_EVENT_SERIES_FROM_OLD = "deriveNewSeriesFromOld",
  CREATE_IMAGE = "image",
  CREATE_INTELLIGENT_INVOICE_CHECK = "intelligentInvoiceCheck",
  CREATE_DOCUMENT_RULE_CHECK = "documentRuleCheck",
  CREATE_REF = "createRef",
  CREATE_REPORT_SUMMARY = "createReportSummary",
  CREATE_TAG = "addTag",
  CREATE_TICKET = "ticket",
  DECOMMISSION_THG = "decommissionThg",
  DELETE_ASSIGNEE = "deleteAssignee",
  DELETE_ASSOCIATED = "deleteAssociated",
  DELETE_BLUEPRINT = "deleteBlueprint",
  DELETE_TAG = "deleteTag",
  EXPORT = "exported",
  IMPORT_THG = "importThg",
  INTERRUPT_EVENT_SERIES_WITH_NEW = "interruptEventSeriesWithNew",
  MANAGE_PROPERTIES_ON_SOURCE = "managePropertiesOnSource",
  MANAGE_TARGETS_ON_SOURCE = "manageTargetSOnSource",
  MESSAGE = "message",
  REQUEST_ATTACHMENT = "attachmentRequest",
  REQUEST_SIGNATURE = "sign-request",
  REQUEST_SNAPSHOT_SIGNATURE = "snapshotSignRequest",
  SEND_PROGRESS_STATUS_UPDATE_MESSAGE = "progressStatusUpdateMessage",
  SHARE = "share",
  SHARE_REPORT_INITIAL = "initialReportShare",
  SIGNED = "signed",
  UPDATE_BANKING = "bankingUpdate",
  UPDATE_DOCUMENT_SHARED = "updateDocumentShared",
  UPDATE_DRIVER = "updateDriver",
  UPDATE_HISTORY_STATUS = "updateHistoryStatus",
  UPDATE_IS_FIXED_STATUS = "isFixedStatusUpdate",
  UPDATE_PROGRESS_STATUS = "progressStatusUpdate",
  UPDATE_REPORT = "reportUpdate",
  UPDATE_STATUS = "updateStatus",
  UPDATE_THG = "updateThg"
}
